import envUrls from "./env-urls";

const REACT_APP_ENV = process.env.REACT_APP_ENV || "dev";

const TRACKING_BASE_URL = envUrls[REACT_APP_ENV]?.trackingURL;

export const getTrackingUrl = (awbNumber) =>
  `${TRACKING_BASE_URL}/${encodeURIComponent(awbNumber)}`;
